import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Message } from 'src/app/api/message';
import { User } from 'src/app/api/user';
import { ChatService } from '../service/chat.service';

@Component({
    selector: 'app-user-card',
    templateUrl: './user-card.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class UserCardComponent implements OnInit {

    @Input() user!: User;

    lastMessage!: Message;

    constructor(private chatService: ChatService) { }

    ngOnInit(): void {
        let filtered = this.user.messages.filter(m => m.ownerId !== 123)
        this.lastMessage = filtered[filtered.length - 1];
    }

    changeView(user: User) {
        this.chatService.changeActiveChat(user);
    }
}
